import React, { useEffect, useState, useCallback } from 'react';
import { get } from '../core/http';
import { API } from '../core/constants';
import EventForm from './EventForm';
import { useLocation, Link } from 'react-router-dom';
import PageHeader from './ui/PageHeader';

const EventsList = () => {
  const [events, setEvents] = useState([]);
  const [visible, setVisible] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState();
  const [loading, setLoading] = useState(true);

  const { search } = useLocation();

  const getEvents = useCallback(async () => {
    const categoryId = new URLSearchParams(search);

    try {
      const result = await get(`${API}/events?${categoryId}`);

      if (result.body) {
        setEvents((_) => result.body);
      }
    } catch (error) {
      console.log('Could not retrieve events');
    } finally {
      setLoading(false);
    }
  }, [search]);

  useEffect(() => {
    getEvents();
  }, [getEvents]);

  const addNewEvent = async () => {
    setSelectedEvent(null);
    setVisible(true);
  };

  const editEvent = (selected) => {
    setSelectedEvent(selected);
    setVisible(true);
  };

  const handleFormSubmit = (event) => {
    getEvents();
    setSelectedEvent(null);
    setVisible(false);
  };

  return (
    <>
      <PageHeader
        title="Events"
        count={!loading ? events.length : null}
        actions={
          <button className="btn btn-primary btn-sm" onClick={() => addNewEvent()}>
            Add new
          </button>
        }
      />

      <div className="bg-base-100 rounded-lg border border-base-300 overflow-x-auto">
        {loading && !events.length ? (
          <p className="text-center text-sm text-base-content/60 py-10">Retrieving events...</p>
        ) : !events.length ? (
          <p className="text-center text-sm text-base-content/60 py-10">No events found for specified filter</p>
        ) : (
          <table className="table table-sm">
            <thead>
              <tr>
                <th></th>
                <th>Title</th>
                <th className="text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {events.map((event) => (
                <tr key={event.id}>
                  <td className="w-14">
                    {event.cover ? (
                      <img src={event.cover} alt="" className="w-10 h-10 rounded object-cover" />
                    ) : (
                      <div className="w-10 h-10 rounded bg-base-300" />
                    )}
                  </td>
                  <td className="font-medium">{event.title}</td>
                  <td>
                    <div className="flex justify-end gap-1.5">
                      <button onClick={() => editEvent(event)} className="btn btn-secondary btn-xs">
                        Edit
                      </button>
                      <Link to={`/articles?eventId=${event.id}`} className="btn btn-ghost btn-xs">
                        View articles
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {visible && <EventForm event={selectedEvent} onFormSubmit={handleFormSubmit} onCancel={() => setVisible(false)} />}
    </>
  );
};

export default EventsList;
